import { Center, Flex, Image, Loader } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { withNotAuth } from 'hocs/withNotAuth';
import { defaultAppConfig } from 'stores/global/RootStore/AppConfigStore';
import { useAppConfig } from 'stores/global/RootStore/context';
import { useDevices } from 'utils/devices';

import s from './RegisterLayout.module.scss';

const RegisterLayout: React.FC = () => {
  const { isDesktop, isPhone, isTablet } = useDevices();
  const { images } = useAppConfig();

  const logo = (
    <Image
      className={s.root__logo}
      src={images.logoUrl}
      style={{ maxWidth: images.logoWidth ?? defaultAppConfig.images.logoWidth }}
    />
  );

  return (
    <Flex className={s.root} align="stretch" justify={isDesktop ? 'center' : 'stretch'}>
      <div className={s.root__wrapper}>
        <Flex className={s.root__content} direction="column" align={isPhone ? 'stretch' : 'center'}>
          <Notifications position="top-center" limit={3} />
          {isDesktop && logo}
          <div className={s.root__form}>
            {isTablet && logo}
            <React.Suspense
              fallback={
                <Center>
                  <Loader />
                </Center>
              }
            >
              <Outlet />
            </React.Suspense>
          </div>
        </Flex>

        {isDesktop && (
          <picture className={s.root__cover}>
            {images.startImageUrlWebp && <source srcSet={images.startImageUrlWebp} type="image/webp" />}
            <img className={s['root__cover-src']} src={images.startImageUrl} alt="Фоновое изображение" />
          </picture>
        )}
        {isPhone && <Image className={s.root__logo} src={images.mobileLogoUrl} />}
      </div>
    </Flex>
  );
};

export default withNotAuth(RegisterLayout);
